<template>
  <!-- 律所介绍 -->
  <section class="bjzc-home-introduction">
    <h2 class="uk-text-center light">{{ $t('sections.introduction') }}</h2>
    <div class="uk-container">
      <div uk-grid class="uk-margin-remove-left">
        <div class="uk-width-1-1 uk-width-2-5@m uk-cover-container border-radius">
          <img src="~@/assets/images/home-about.png" alt="" uk-cover />
        </div>
        <div class="uk-width-1-1 uk-width-3-5@m border-radius">
          <div v-html="$t('about.home_content')"></div>
          <button class="bjzc-button uk-margin uk-visible@m" @click="more">
            {{ $t('messages.more_introduction') }}
          </button>
        </div>
      </div>
    </div>
    <div class="more-btn-wrapper uk-text-center uk-hidden@m">
      <button class="bjzc-button" @click="more">{{ $t('messages.more_introduction') }}</button>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    more() {
      this.$router.push({ name: 'About' })
    }
  }
}
</script>

<style lang="scss">
.bjzc-home-introduction {
  background-image: url('~@/assets/images/bg/section-3.png');
  background-position: 50% top;
  background-repeat: repeat-x;
  .uk-container > div > * {
    min-height: 20rem;
  }

  .uk-container > div > :nth-child(2) {
    padding: 2.5rem;
    background-image: url('~@/assets/images/bg/section-2.png');
    background-position: 0;
  }
}

@media (max-width: ($screen-width-m - 1)) {
  .bjzc-home-introduction {
    .uk-container > div > * {
      min-height: 14rem;
    }
    .uk-container > div > :nth-child(2) {
      padding: 1.25rem 1rem;
      order: -1;
      p {
        margin-bottom: 0;
      }
    }
    .uk-grid > .uk-grid-margin {
      margin-top: 10px;
    }
  }
}
</style>
